<template lang="pug">
v-container(fluid)
  div(class="d-flex justify-space-between mb-2")
    h2(class="blue-grey--text")
      v-icon(class="mr-1") mdi-magnify
      span 報名查詢
    AnalyzeDialog(:analyzeData="analyzeData")
  SearchForm(
    @exportTable="handleExportTable"
    @exportData="handleExportData"
    @search="handleSearch"
  )
  v-row(class="my-1")
    v-col(cols="6" md="3")
      v-card(
        class="pa-3"
        color="cyan lighten-4"
        outlined)
        span 總人數: {{ totalCount }}
    v-col(cols="6" md="3")
      v-card(
        class="pa-3"
        color="cyan lighten-4"
        outlined)
        span 弟兄人數: {{ maleCount }}
    v-col(cols="6" md="3")
      v-card(
        class="pa-3"
        color="cyan lighten-4"
        outlined)
        span 姐妹人數: {{ femaleCount }}
    v-col(cols="6" md="3")
      v-card(
        class="pa-3"
        color="orange lighten-4"
        outlined)
        span 未繳費: {{ noPayCount }}
  v-divider(class="my-4")
  SearchTable(
    :data="listData"
    @update="handleUpdate"
    @delete="handleDelete"
  )
</template>

<script>
import AnalyzeDialog from '@/components/common/analyzeDialog'
import SearchForm from '@/components/registration/searchForm'
import SearchTable from '@/components/registration/searchTable'
export default {
  name: 'registrationSearch',
  components: {
    AnalyzeDialog,
    SearchForm,
    SearchTable
  },
  data: () => ({
    analyzeData: {},
    group: [],
    listData: [],
    totalCount: 0,
    maleCount: 0,
    femaleCount: 0,
    noPayCount: 0
  }),
  methods: {
    async getClcGroupSelect () {
      try {
        let groupRes = await this.$api.registration.registrationAPI.getClcGroupSelect()
        this.$store.dispatch('group/setGroup', groupRes.data.content)
      } catch (err) {
        console.log(err)
      }
    },
    async getList (payload) {
      try {
        let listRes = await this.$api.registration.registrationAPI.getList(payload)
        if (listRes.data.success) {
          this.listData = listRes.data.content.listLoveSevenRegistration
          this.totalCount = listRes.data.content.totalCount
          this.maleCount = listRes.data.content.maleCount
          this.femaleCount = listRes.data.content.femaleCount
          this.noPayCount = listRes.data.content.noPayCount
        }
        if (!listRes.data.success && listRes.data.showalert) {
          this.$store.dispatch('notification/openNotification', { 
            msg : listRes.data.message,
            color : "red",
            timeout: 5000, 
            showClose: false 
          })
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleSearch (searchPayload) {
      this.getList(searchPayload)
    }, 
    async analyze () {
      try {
        let res = await this.$api.registration.registrationAPI.analyze()
        this.analyzeData = res.data.content
      } catch (err) {
        console.log(err)
      }
    },
    async handleExportTable () {
      try {
        let res = await this.$api.registration.registrationAPI.exportTable({responseType: 'blob'})
        const blob = new Blob([res.data], { type: res.headers['content-type'] })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.click()
        link.remove()
      } catch (err) {
        console.log(err)
      }
    },
    async handleExportData () {
      try {
        let res = await this.$api.registration.registrationAPI.exportData({responseType: 'blob'})
        const blob = new Blob([res.data], { type: res.headers['content-type'] })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.click()
        link.remove()
      } catch (err) {
        console.log(err)
      }
    },
    async handleUpdate(item) {
      try {
        await this.$api.registration.registrationAPI.modify(item)
        this.$store.dispatch('notification/openNotification', { 
          msg : `${item.name} 報名資料已更新`,
          color : "green",
          timeout: 5000, 
          showClose: false 
        })
        this.getList({})
      } catch (err) {
        console.log(err)
      }
    },
    async handleDelete (item) {
      try {
        await this.$api.registration.registrationAPI.delete({ id: item.registrationId })
        this.$store.dispatch('notification/openNotification', { 
          msg : `${item.name} 報名資料已刪除`,
          color : "green",
          timeout: 5000, 
          showClose: false 
        })
        this.getList({})
      } catch (err) {
        console.log(err)
      }
    }
  },
  created () {
    this.getClcGroupSelect()
    this.getList({})
    this.analyze()
  }
}
</script>
